import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { ModalBeneficiariesTableComponent } from './modal-beneficiaries-table/modal-beneficiaries-table.component';
import { ModalWithdrawalTransferDetailComponent } from './modal-withdrawal-transfer-detail/modal-withdrawal-transfer-detail.component';
import { OperationDepositDetailsDrawerComponent } from './operation-deposit-details-drawer/operation-deposit-details-drawer.component';
import { OperationRetirementDetailsDrawerComponent } from './operation-retirement-details-drawer/operation-retirement-details-drawer.component';
import { OperationAcxTradeDetailsDrawerComponent } from './operation-acx-trade-details-drawer/operation-acx-trade-details-drawer.component';
import { OperationB3WithdrawalTransferDetailsDrawerComponent } from './operation-b3-withdrawal-transfer-details-drawer/operation-b3-withdrawal-transfer-details-drawer.component';
import { OperationCustodyWithdrawalDetailsDrawerComponent } from './operation-custody-withdrawal-details-drawer/operation-custody-withdrawal-details-drawer.component';
import { OperationTransferDetailsDrawerComponent } from './operation-transfer-details-drawer/operation-transfer-details-drawer.component';
import { OperationListFilterComponent } from './operation-list-filter/operation-list-filter.component';
import { OperationListTableComponent } from './operation-list-table/operation-list-table.component';
import { OperationListComponent } from './operation-list.component';

@NgModule({
  declarations: [
    OperationListComponent,
    OperationListTableComponent,
    OperationListFilterComponent,
    ModalBeneficiariesTableComponent,
    ModalWithdrawalTransferDetailComponent,
    OperationDepositDetailsDrawerComponent,
    OperationRetirementDetailsDrawerComponent,
    OperationTransferDetailsDrawerComponent,
    OperationCustodyWithdrawalDetailsDrawerComponent,
    OperationAcxTradeDetailsDrawerComponent,
    OperationB3WithdrawalTransferDetailsDrawerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    OperationListComponent,
    ModalBeneficiariesTableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OperationListModule {}
